import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Trash2, RefreshCw, Clock, User } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminSessions = () => {
  const [sessions, setSessions] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchSessions = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/admin/sessions`, { withCredentials: true });
      setSessions(res.data.sessions);
      setTotal(res.data.total);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, []);

  useEffect(() => { fetchSessions(); }, [fetchSessions]);

  const revokeSession = async (token) => {
    if (!window.confirm('Revoke this session?')) return;
    try {
      await axios.delete(`${API}/admin/sessions/${token}`, { withCredentials: true });
      fetchSessions();
    } catch (e) { alert('Error revoking session'); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <span style={{ fontSize: 14, color: '#8885a0' }}>{total} sessions total</span>
        <button onClick={fetchSessions} style={{ padding: '10px 16px', borderRadius: 10, border: '1px solid rgba(139,92,246,0.3)', background: 'rgba(88,28,135,0.12)', color: '#b0adc0', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
          <RefreshCw size={14} /> Refresh
        </button>
      </div>

      <div style={{ background: 'rgba(88,28,135,0.08)', border: '1px solid rgba(139,92,246,0.15)', borderRadius: 14, overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 700 }}>
          <thead>
            <tr style={{ borderBottom: '1px solid rgba(139,92,246,0.15)' }}>
              {['User', 'Email', 'Token (prefix)', 'Status', 'Created', 'Expires', 'Actions'].map(h => (
                <th key={h} style={{ padding: '14px 16px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#8885a0', textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ padding: 40, textAlign: 'center', color: '#8885a0' }}>Loading...</td></tr>
            ) : sessions.length === 0 ? (
              <tr><td colSpan={7} style={{ padding: 40, textAlign: 'center', color: '#8885a0' }}>No sessions found</td></tr>
            ) : sessions.map((s, i) => (
              <tr key={i} style={{ borderBottom: '1px solid rgba(139,92,246,0.08)', opacity: s.is_expired ? 0.5 : 1 }}>
                <td style={{ padding: '12px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <User size={14} color="#8885a0" />
                    <span style={{ fontSize: 13, color: '#e0dff0' }}>{s.user_name}</span>
                  </div>
                </td>
                <td style={{ padding: '12px 16px', fontSize: 12, color: '#8885a0' }}>{s.user_email}</td>
                <td style={{ padding: '12px 16px', fontSize: 11, color: '#6b6880', fontFamily: 'monospace' }}>{s.session_token?.substring(0, 20)}...</td>
                <td style={{ padding: '12px 16px' }}>
                  <span style={{ padding: '3px 10px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: s.is_expired ? 'rgba(239,68,68,0.15)' : 'rgba(34,197,94,0.15)', color: s.is_expired ? '#ef4444' : '#22c55e' }}>
                    {s.is_expired ? 'Expired' : 'Active'}
                  </span>
                </td>
                <td style={{ padding: '12px 16px', fontSize: 12, color: '#8885a0' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Clock size={12} /> {s.created_at ? new Date(s.created_at).toLocaleString() : 'N/A'}</div>
                </td>
                <td style={{ padding: '12px 16px', fontSize: 12, color: '#8885a0' }}>{s.expires_at ? new Date(s.expires_at).toLocaleString() : 'N/A'}</td>
                <td style={{ padding: '12px 16px' }}>
                  <button onClick={() => revokeSession(s.session_token)} style={{ width: 30, height: 30, borderRadius: 8, border: 'none', background: 'rgba(239,68,68,0.12)', color: '#ef4444', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminSessions;
